import type { WorkoutWheelConfig } from '../types';

/** Built-in lists; used when the user has no DB row and as reference for “reset to defaults”. */
export const DEFAULT_WORKOUT_WHEEL_CONFIG: WorkoutWheelConfig = {
  spinCount: 3,
  copiesGreen: 3,
  copiesYellow: 2,
  copiesRed: 1,
  green: [
    { id: 'pushups', name: 'Push-ups', prescription: '10 reps' },
    { id: 'dips', name: 'Dips', prescription: '10 reps' },
    { id: 'squats', name: 'Squats', prescription: '10 reps' },
    { id: 'lunges', name: 'Lunges', prescription: '5 each leg' },
    { id: 'crunches', name: 'Crunches', prescription: '15 reps' },
    { id: 'jumping-jacks', name: 'Jumping jacks', prescription: '30 sec' },
    { id: 'burpees', name: 'Burpees', prescription: '5 reps' },
    { id: 'incline-pushups', name: 'Incline push-ups', prescription: '10 reps' },
    { id: 'leg-raises', name: 'Leg raises', prescription: '5 reps' },
    { id: 'pullups', name: 'Pull-ups', prescription: '1 rep' },
    { id: 'chinups', name: 'Chin-ups', prescription: '1 rep' },
    { id: 'dead-hang', name: 'Dead hang', prescription: '30 sec' },
    { id: 'face-pulls', name: 'Face pulls', prescription: '10 reps' },
    { id: 'bands-triceps-pull', name: 'Bands triceps pull', prescription: '10 reps' },
    { id: 'bands-biceps-pull', name: 'Bands biceps pull', prescription: '10 reps' },
  ],
  yellow: [
    { id: 'pushups', name: 'Push-ups', prescription: '15 reps' },
    { id: 'dips', name: 'Dips', prescription: '15 reps' },
    { id: 'squats', name: 'Squats', prescription: '20 reps' },
    { id: 'lunges', name: 'Lunges', prescription: '10 reps' },
    { id: 'crunches', name: 'Crunches', prescription: '15 reps' },
    { id: 'jumping-jacks', name: 'Jumping jacks', prescription: '60 sec' },
    { id: 'burpees', name: 'Burpees', prescription: '10 reps' },
    { id: 'incline-pushups', name: 'Incline push-ups', prescription: '15 reps' },
    { id: 'plank', name: 'Plank', prescription: '30 sec' },
    { id: 'side-plank', name: 'Side plank', prescription: '20 sec' },
    { id: 'leg-raises', name: 'Leg raises', prescription: '10 reps' },
    { id: 'decline-pushups', name: 'Decline push-ups', prescription: '5 reps' },
    { id: 'pullups', name: 'Pull-ups', prescription: '3 reps' },
    { id: 'chinups', name: 'Chin-ups', prescription: '3 reps' },
    { id: 'dead-hang', name: 'Dead hang', prescription: '45 sec' },
  ],
  red: [
    { id: 'pushups', name: 'Push-ups', prescription: '20 reps' },
    { id: 'dips', name: 'Dips', prescription: '20 reps' },
    { id: 'squats', name: 'Squats', prescription: '50 reps' },
    { id: 'lunges', name: 'Lunges', prescription: '20 reps' },
    { id: 'crunches', name: 'Crunches', prescription: '50 reps' },
    { id: 'jumping-jacks', name: 'Jumping jacks', prescription: '90 sec' },
    { id: 'burpees', name: 'Burpees', prescription: '20 reps' },
    { id: 'incline-pushups', name: 'Incline push-ups', prescription: '20 reps' },
    { id: 'plank', name: 'Plank', prescription: '60 sec' },
    { id: 'side-plank', name: 'Side plank', prescription: '30 sec' },
    { id: 'leg-raises', name: 'Leg raises', prescription: '15 reps' },
    { id: 'decline-pushups', name: 'Decline push-ups', prescription: '10 reps' },
    { id: 'pullups', name: 'Pull-ups', prescription: 'AMRAP' },
    { id: 'chinups', name: 'Chin-ups', prescription: 'AMRAP' },
    { id: 'dead-hang', name: 'Dead hang', prescription: '60 sec' },
  ],
};
